export function mobileNav() {
    const body = $("body");
    const $window = $(window);
    const btnMenu = $(".btn-menu");
    const arrowLink = `<span class="arrow">
<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.03699 23L6.5 21.5382L14.426 14L6.5 6.46179L8.03699 5L17.5 14L8.03699 23Z" fill="white"/>
</svg>
</span>`;

    btnMenu.on("click", function (e) {
        let $this = $(this);
        if (!$this.hasClass("open")) {
            $this.addClass("open");
            body.addClass("menu-opened");
        } else {
            $this.removeClass("open");
            body.removeClass("menu-opened");
        }
        e.preventDefault();
    });

    $(arrowLink).insertBefore(".main-menu .sub-menu");

    function closeDropdown(e) {
        if (!$('.main-menu .menu-item-has-children').has(e.target).length > 0) {
            $('.main-menu .menu-item-has-children').removeClass('active').find(".sub-menu").slideUp();
            window.removeEventListener('click', closeDropdown);
        }
    }


    $(document).on("click", ".main-menu .menu-item-has-children > a, .main-menu .arrow", function (e) {
        e.preventDefault();

        let $this = $(this);
        let parent = $this.parent();
        if (!parent.hasClass("active")) {
            if (window.innerWidth >= 1200) {
                $('.main-menu .menu-item-has-children').removeClass('active').find(".sub-menu").slideUp();
            }
            parent.addClass("active").find(".sub-menu").slideDown();
            window.addEventListener('click', closeDropdown);
        } else {
            window.removeEventListener('click', closeDropdown);
            parent.removeClass("active").find(".sub-menu").slideUp();
        }
    });

    window.addEventListener("resize", function () {
        if (window.innerWidth >= 1200) {
            body.removeClass("menu-opened");
            $('.main-menu .menu-item-has-children').removeClass('active').find(".sub-menu").slideUp();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileNav.js